export default function ContactSection() {
  const handleWhatsAppClick = () => {
    window.open('https://wa.me/5544999957005', '_blank');
  };

  return (
    <section id="contact" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-primary mb-4">
            Fale Conosco
          </h2>
          <p className="text-lg text-text-grey max-w-3xl mx-auto">
            Pronto para vencer licitações com segurança? Entre em contato com nossa equipe e descubra como podemos ajudar sua empresa.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 mb-12">
          <div className="flex flex-col items-center text-center space-y-4 p-6 bg-light-grey rounded-lg">
            <div className="w-16 h-16 flex items-center justify-center bg-primary rounded-lg">
              <i className="ri-map-pin-line text-2xl text-white"></i>
            </div>
            <div>
              <h3 className="text-xl font-semibold text-primary mb-2">Localização</h3>
              <p className="text-text-grey">
                Campo Mourão, PR<br />
                Brasil
              </p>
            </div>
          </div>

          <div className="flex flex-col items-center text-center space-y-4 p-6 bg-light-grey rounded-lg">
            <div className="w-16 h-16 flex items-center justify-center bg-primary rounded-lg">
              <i className="ri-phone-line text-2xl text-white"></i>
            </div>
            <div>
              <h3 className="text-xl font-semibold text-primary mb-2">Telefone</h3>
              <p className="text-text-grey">
                (44) 99995-7005<br />
                Seg-Sex, 9h-18h
              </p>
            </div>
          </div>

          <div className="flex flex-col items-center text-center space-y-4 p-6 bg-light-grey rounded-lg">
            <div className="w-16 h-16 flex items-center justify-center bg-primary rounded-lg">
              <i className="ri-mail-line text-2xl text-white"></i>
            </div>
            <div>
              <h3 className="text-xl font-semibold text-primary mb-2">E-mail</h3>
              <p className="text-text-grey">
                contato@licitmax.com.br<br />
                Resposta em até 24 horas
              </p>
            </div>
          </div>
        </div>

        <div className="text-center">
          <button 
            onClick={handleWhatsAppClick}
            className="inline-flex items-center gap-3 px-10 py-5 bg-accent text-primary font-semibold text-lg rounded-lg hover:bg-accent/90 hover:scale-105 transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
          >
            <i className="ri-whatsapp-line text-2xl"></i>
            Falar com Especialista
          </button>
          <p className="text-text-grey mt-4 text-sm">
            Atendimento rápido via WhatsApp
          </p>
        </div>
      </div>
    </section>
  );
}
